import { Box, Checkbox, Divider, FormControlLabel, Grid, Theme, Typography } from '@mui/material';
import { ApplicationProps } from '../../redux-store/types/api-types';
import { Gridstyles } from './index';
import { KeyValue } from './personalDetails';
import { useDispatch, useSelector } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';
import { useEffect, useState } from 'react';
import { LocationType, mdmsLocationList } from '../../redux-store/types/mdms';
import { getLocationList } from '../../redux-store/actions';
import { PHYSICAL_DIGITAL_FLOW } from '../../utils/constant';

export default function DistributorDetails({
  application,
  isDiyInvestorOnboarding,
  hideBseESignStatus = false
}: {
  application: ApplicationProps;
  isDiyInvestorOnboarding?: boolean;
  hideBseESignStatus?: boolean;

}): JSX.Element {
  const { isBSEEnabled, isEsignEnabled, onboardingFlowType } = application || {};
  const { auth } = useSelector((store: RootStateType) => store);
  const isSupportRM = isDiyInvestorOnboarding ? false : auth.id === application?.supportRm?.userId;
  const LoginRMorSupport = isSupportRM ? application?.supportRm : application?.rm;
  const [locationMaster, setLocationMaster] = useState<mdmsLocationList[]>([]);

  const isFromDiy = onboardingFlowType ? onboardingFlowType?.toLowerCase() === 'diy' : false
  const dispatch = useDispatch();
  useEffect(() => {
    (async function () {
      try {
        const locationmaster = (await dispatch(getLocationList())) as unknown as LocationType;
        setLocationMaster(locationmaster.rmLocationList);
      } catch (e) {
        console.log((e as Error).message);
      }
    })();
  }, []);
  return (
    <>
      <Box
        sx={(theme: Theme) => ({
          bgcolor: 'white',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
          borderRadius: '10px',
          border: `1px solid ${theme.palette.grey[100]}`,
          padding:{xs:"15px",sm:'25px'},
        })}>
        <Box>
          <Grid container>
            <Grid item xs={12}>
              <Typography sx={(theme: Theme) => ({ fontSize: 18, fontWeight: 700, color: theme.palette.primary[900], mb: '9px' })}>
                RM Details
              </Typography>
            </Grid>

            {/* <Gridstyles> */}
            {!isDiyInvestorOnboarding && (
              <Grid
                item
                container
                // pt={1}
                // pb={5}
                rowSpacing={3}
                columnSpacing={5.5}
                direction="row"
              // justifyContent="space-between"
              // alignItems="flex-start"
              >
                <KeyValue
                  title={isSupportRM ? "Service RM's Name" : "RM's Name"}
                  description={LoginRMorSupport?.user?.firstName}
                />
                <KeyValue
                  title={isSupportRM ? "Service RM's Email Address" : "RM's Email Address"}
                  description={LoginRMorSupport?.user?.email}
                />
                <KeyValue
                  title={isSupportRM ? "Service RM's Mobile Number" : "RM's Mobile Number"}
                  description={
                    LoginRMorSupport?.user?.countryCode
                      ? LoginRMorSupport?.user?.countryCode + '-' + LoginRMorSupport?.user?.phone
                      : LoginRMorSupport?.user?.phone
                  }
                />
                <KeyValue
                  title={'Location'}
                  // description={
                  //   locationMaster.find((loc) => loc.key === LoginRMorSupport?.location)?.value
                  // }
                  description={LoginRMorSupport?.branchName}
                />
                {isSupportRM && (
                  <>
                    <KeyValue title={"RM's Name"} description={application?.rm?.user?.firstName} />
                    <KeyValue
                      title={"RM's Email Address"}
                      description={application?.rm?.user?.email}
                    />
                    <KeyValue
                      title={"RM's Mobile Number"}
                      description={
                        application?.rm?.user?.countryCode
                          ? application?.rm?.user?.countryCode + '-' + application?.rm?.user?.phone
                          : application?.rm?.user?.phone
                      }
                    />
                    <KeyValue
                      title={'Location'}
                      description={
                        locationMaster.find((loc) => loc.key === application?.rm?.location)?.value
                      }
                    />
                  </>
                )}

                {!hideBseESignStatus && PHYSICAL_DIGITAL_FLOW && (
                  <>
                    <Grid item xs={12}>
                      <Divider sx={{ color: 'red', mt: 2 }} />
                    </Grid>

                    <Grid item xs={12}>
                      <Typography variant='h2' mt={2}>BSE and E-Sign Status</Typography>
                    </Grid>

                    <Grid item container mt={3}>
                      <Grid item xs={12} >
                        <FormControlLabel sx={{ "&.MuiFormControlLabel-root": { cursor: "not-allowed" } }} checked={isBSEEnabled} control={<Checkbox />} disabled label={<Typography variant="body_500" color='text.secondary'>Sent to BSE</Typography>} />

                      </Grid>
                      <Grid item xs={12} >
                        <FormControlLabel sx={{ "&.MuiFormControlLabel-root": { cursor: "not-allowed" } }} control={<Checkbox />} disabled checked={isEsignEnabled} label={<Typography variant="body_500" color='text.secondary'>Sent To E-Sign</Typography>} />
                      </Grid>
                    </Grid>
                  </>
                )}
              </Grid>
            )}
            {isDiyInvestorOnboarding && (
              <Grid
                item
                container
                rowSpacing={3}
                columnSpacing={5.5}
                direction="row"
              >
                <KeyValue
                  title={"RM's Name"}
                  description={application?.rm?.user?.firstName}
                />
              </Grid>
            )}
          </Grid>
          {/* </Gridstyles> */}
        </Box>
      </Box >
    </>
  );
}
